import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'apCurrency',
    standalone: false
})
export class ApCurrencyPipe implements PipeTransform {

  constructor(private translateService: TranslateService) { }

  transform(value: number, noData = false): string {
    if (!value || isNaN(value)) { value = 0; }
    if (noData && value === 0) { return '-'; }
    return new Intl.NumberFormat(this.translateService.currentLang, { style: 'currency', currency: 'EUR' }).format(value);
  }
}
